import { render, staticRenderFns } from "./modal-subscriber-details.vue?vue&type=template&id=1649d6ec&scoped=true&"
import script from "./modal-subscriber-details.vue?vue&type=script&lang=js&"
export * from "./modal-subscriber-details.vue?vue&type=script&lang=js&"
import style0 from "./modal-subscriber-details.vue?vue&type=style&index=0&id=1649d6ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1649d6ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1649d6ec')) {
      api.createRecord('1649d6ec', component.options)
    } else {
      api.reload('1649d6ec', component.options)
    }
    module.hot.accept("./modal-subscriber-details.vue?vue&type=template&id=1649d6ec&scoped=true&", function () {
      api.rerender('1649d6ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/modals/modal-subscriber-details.vue"
export default component.exports